import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  gridLeft: {
    height: "100vh",
    overflow: "hidden",
  },
  gridRight: {
    height: "100%",
    overflowY: "auto",
    //
    width: "100%",
  },
  rightBoxWrapper: {
    minHeight: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: "20px 35px",
    background: "#f4f6fa",
    //
    width: "100%",
  },
  rightBoxInnerWrapper: {
    width: "100%",
    maxWidth: "350px",
  },
}));
export default useStyles;
